import { createContext, useContext, type ReactNode } from 'react';
import { useSystemStatus } from '../hooks/useSystemStatus';
import type { SystemStatus } from '../types/system';

interface SystemStatusContextValue {
  status: SystemStatus | null;
  loading: boolean;
  refresh: () => Promise<void>;
  updateAvailable: boolean;
  acknowledgeUpdate: (buildId: string) => void;
  reloadForUpdate: (buildId: string) => void;
}

const SystemStatusContext = createContext<SystemStatusContextValue | null>(null);

export function SystemStatusProvider({ children }: { children: ReactNode }) {
  const value = useSystemStatus();
  return (
    <SystemStatusContext.Provider value={value}>
      {children}
    </SystemStatusContext.Provider>
  );
}

export function useSystemStatusContext(): SystemStatusContextValue {
  const ctx = useContext(SystemStatusContext);
  if (!ctx) {
    throw new Error('useSystemStatusContext must be used within SystemStatusProvider');
  }
  return ctx;
}
